import { useMemo } from 'react';

import { DocumentType } from '@/types/schema';
import { getNodes } from '@/utils/graphqlUtils';

import { useEntityDocumentViewerQuery } from '../../components/HouseholdDocumentsViewer/graphql/EntityDocumentViewer.generated';
import { getCompatibleDocumentTypes } from '../utils/ManageDocumentAmendments.utils';

export function useVersionableDocuments(
  householdId: string | null,
  currentDocumentId: string,
  currentDocumentType: DocumentType
) {
  const compatibleDocumentTypes =
    getCompatibleDocumentTypes(currentDocumentType);
  // Query for all household documents of eligible types
  const { data, loading } = useEntityDocumentViewerQuery({
    variables: {
      targetId: '', // Not needed for this use case
      isEntity: false,
      isTestamentaryEntity: false,
      includeTargetDocuments: false,
      targetHouseholdDocumentsWhere: {
        hasHouseholdWith: [{ id: householdId }],
        typeIn: compatibleDocumentTypes,
      },
      allHouseholdDocumentsWhere: {
        hasHouseholdWith: [{ id: householdId }],
        typeIn: compatibleDocumentTypes,
      },
    },
    fetchPolicy: 'cache-and-network',
    skip: !householdId,
  });

  // Get all household documents and filter out those already in the chain
  const selectable = useMemo(() => {
    return (
      getNodes(data?.allHouseholdDocuments)
        // Don't show the current document in the list of selectable documents
        .filter((doc) => doc.id !== currentDocumentId)
        .map((doc) => ({
          id: doc.id,
          name: doc.name,
          type: doc.type,
        }))
    );
  }, [data?.allHouseholdDocuments, currentDocumentId]);

  return {
    loading,
    selectable,
  };
}
